"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSignal = validateSignal;
exports.validateSignalsFloatingBehavior = validateSignalsFloatingBehavior;
const BoundaryLevel_1 = require("../../BoundaryLevel");
const ComponentValidationResult_1 = require("../../ComponentValidationResult");
function validateSignal(signal) {
    const errors = [];
    const attributes = signal.attributes ?? {};
    if (attributes.noConnect && Object.values(attributes).filter((attr) => attr).length > 1) {
        errors.push({
            type: ComponentValidationResult_1.ComponentValidationErrorType.InternalConsistencyError,
            message: `Signal '${signal.name}': noConnect cannot be set with any other attribute`,
            severity: BoundaryLevel_1.BoundaryLevel.Error,
            locator: { signalId: signal.id, propertyKey: 'attributes.noConnect' },
        });
    }
    if (attributes.power && attributes.ground) {
        errors.push({
            type: ComponentValidationResult_1.ComponentValidationErrorType.InternalConsistencyError,
            message: `Signal '${signal.name}': power and ground cannot both be set`,
            severity: BoundaryLevel_1.BoundaryLevel.Error,
            locator: { signalId: signal.id, propertyKey: 'attributes' },
        });
    }
    if (attributes.digital && !signal.supportedDriveModes?.length) {
        errors.push({
            type: ComponentValidationResult_1.ComponentValidationErrorType.InternalConsistencyError,
            message: `Signal '${signal.name}': Digital signal must have at least one drive mode specified`,
            severity: BoundaryLevel_1.BoundaryLevel.Error,
            locator: { signalId: signal.id, propertyKey: 'supportedDriveModes' },
        });
    }
    if (!attributes.digital && signal.supportedDriveModes?.length) {
        errors.push({
            type: ComponentValidationResult_1.ComponentValidationErrorType.InternalConsistencyError,
            message: `Signal '${signal.name}': Drive modes may only be set on digital signals`,
            severity: BoundaryLevel_1.BoundaryLevel.Error,
            locator: { signalId: signal.id, propertyKey: 'supportedDriveModes' },
        });
    }
    if (attributes.activeLow && !attributes.digital) {
        errors.push({
            type: ComponentValidationResult_1.ComponentValidationErrorType.InternalConsistencyError,
            message: `Signal '${signal.name}': activeLow may only be set on digital signals`,
            severity: BoundaryLevel_1.BoundaryLevel.Error,
            locator: { signalId: signal.id, propertyKey: 'attributes.activeLow' },
        });
    }
    return errors;
}
const FLOATING_BEHAVIOR_EXEMPT_SIGNAL_COUNT = 2;
function validateSignalsFloatingBehavior(signals) {
    if (signals.length <= FLOATING_BEHAVIOR_EXEMPT_SIGNAL_COUNT) {
        return [];
    }
    const errors = [];
    for (const signal of signals) {
        if (!signal.isCadstromInternal && signal.floatingBehavior === undefined) {
            errors.push({
                type: ComponentValidationResult_1.ComponentValidationErrorType.InternalConsistencyError,
                message: `Signal '${signal.name}': floating behaviour must be specified`,
                severity: BoundaryLevel_1.BoundaryLevel.Error,
                locator: { signalId: signal.id, propertyKey: 'floatingBehavior' },
            });
        }
    }
    return errors;
}
//# sourceMappingURL=SignalValidation.js.map